import styled, { css } from 'styled-components'

export interface ViewSwitchButtonProps {
  $active?: boolean
}

export const Container = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: 4px;
  gap: 4px;
  box-shadow: ${({ theme }) => theme.shadows.md};
  z-index: 10;
`

export const ViewSwitchButton = styled.button.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<ViewSwitchButtonProps>`
  padding: 8px 16px;
  border: none;
  background: transparent;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: 13px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.secondary};
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  gap: 6px;
  position: relative;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.colors.text.primary};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .icon {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
  }

  ${({ $active, theme }) =>
    $active &&
    css`
      background: ${theme.colors.primary};
      color: ${theme.colors.text.inverse};
      box-shadow: none;

      &:hover:not(:disabled) {
        color: ${theme.colors.text.inverse};
      }
    `}
`
